
+(function($) {
   var articleTeaserLoader = function(element, options) {
       var self = this;
       var elem = $(element);
       var blockCount = 0;
       var settings = $.extend({
           pageId: 0,
           dossierId: 0,
           articleId: 0,
           tagId: 0,
           from: 0,
           teaserContainer: '.teasers',
           loadButton: '.load-button'
       }, options);

       this.loadTeasers = function() {
           $.getJSON('/site/ajax/get_related_articles.php', {
               page_id: settings.pageId,
               tag_id: settings.tagId,
               article_id: settings.articleId,
               dossier_id: settings.dossierId,
               from: settings.from
           }, function(data) {
               settings.from += data.articles.length;

               if (settings.from >= data.total) {
                   elem.find(settings.loadButton).addClass('disabled');
               }

               if (data.total == 0) {
                   elem.hide();
               }

               for (var i in data.articles) {
                   addTeaserBlock(data.articles[i]);
               }
           });
       };

       var addTeaserBlock = function(teaser) {
           blockCount++;

		   var blockMod   = blockCount % 5;
           var blockClass = blockMod == 1 || blockMod == 2 ? 'col-sm-6' : 'col-sm-6 col-md-4';
           var blockElem  = $('<div class="' + blockClass + ' teaser loading init teaser-' + teaser.id + '"><div class="teaser-inner"/></div>');

           blockElem.find('.teaser-inner').html(teaser.html);
           elem.find(settings.teaserContainer).append(blockElem);
           setTimeout(function() { blockElem.removeClass('init'); }, 10);

           var blockImages = [];
           var imagesLoaded = 0;
           var $teaserElement = blockElem.find('.teaser-template');

           $teaserElement.imageLoader({
               onLoad: function() {
                   blockElem.removeClass('loading');
               }
           });
       };

       elem.find(settings.teaserContainer).find('.teaser').remove();
       this.loadTeasers();

       elem.find(settings.loadButton).on('click', function(e) {
           e.preventDefault();
           self.loadTeasers();
       });
   };

   $.fn.articleTeaserLoader = function(options) {
       return this.each(function() {
           var element = $(this);

           if (element.data('articleTeaserLoader')) return;
           element.data('articleTeaserLoader', new articleTeaserLoader(this, options));
       });
   };
})(jQuery);
